import React from 'react'
import T from 'prop-types'
import Joi from 'joi'
import Button from 'components/Button'
import Editorial from 'components/Editorial'
import getGenderText from 'apps/booking/helpers/getGenderText'

import Step from '../../components/Step'

export const validator = () =>
  Joi.object({
    riskGroupA: Joi.boolean().required(),
  }).unknown(true)

// Show this step if:
// User wants to be on the waitinglist
export const riskGroupAPredicate = (values) => {
  if (values?.details?.on_behalf_of?.national_id) {
    return false
  }
  return !values?.vaccinationId && values?.rejection === 'venteliste'
}

export default function RiskGroupA({ changeStep, values, onChange }) {
  // Update and save answer
  const handleChange = (answer) => () => {
    onChange('riskGroupA', answer)
  }

  // Get saved answer (used for prefilling button status)
  const status = values?.riskGroupA

  // Handle refuse (privacy compliant)
  const handleRefuse = () => {
    onChange('riskGroupA', false)
    changeStep()
  }

  const isBookingOnBehalfOf = Boolean(values?.details?.on_behalf_of?.national_id)

  return (
    <Step
      title={getGenderText('Har %s underliggende sykdom?', values)}
      onSubmit={changeStep}
      submit="Gå videre"
      submitDisabled={status === undefined}
    >
      <Editorial>
        <p>Personer med én eller flere av tilstandene på listen under skal prioriteres høyere.</p>
        <h3>Gruppe A</h3>
        <ul>
          <li>Organtransplantasjon</li>
          <li>Immunsvikt</li>
          <li>Hematologisk kreftsykdom siste fem år</li>
          <li>Annen aktiv kreftsykdom</li>
          <li>Pågående eller nylig avsluttet kreftbehandling</li>
          <li>
            Nevrologiske sykdommer eller muskelsykdommer som medfører nedsatt hostekraft eller
            lungefunksjon
          </li>
          <li>Kronisk/alvorlig nyresykdom</li>
        </ul>
      </Editorial>

      <Button inline small onClick={handleChange(true)} selected={status === true}>
        {isBookingOnBehalfOf
          ? getGenderText('Ja, %s har én eller flere av tilstandene på listen over', values)
          : 'Ja, jeg har én eller flere av tilstandene på listen over'}
      </Button>

      <Button inline small onClick={handleChange(false)} selected={status === false}>
        {isBookingOnBehalfOf
          ? getGenderText('Nei, %s har ingen av tilstandene på listen over', values)
          : 'Nei, jeg har ingen av tilstandene på listen over'}
      </Button>

      <p>
        Dersom du ikke ønsker å oppgi, kan du{' '}
        <button onClick={handleRefuse} style={{ textDecoration: 'underline' }}>
          trykke her
        </button>
        .
      </p>
    </Step>
  )
}

RiskGroupA.propTypes = {
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
  orgUnit: T.shape({
    id: T.string.isRequired,
    slug: T.string.isRequired,
  }).isRequired,
}
